import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'Components';
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import './SplitReport_SingleSample.css';
import CustomIcon from './CustomIcon';

const SplitReport_SingleSample = ({ onButtonClick, title, subTitle }) => (
  <div>
    <Button
      onClick={onButtonClick}
      className="actions__SplitReport_SingleSample"
    >
      <div className="actions__SplitReport_SingleSample__text">
        <div>{title}</div>
        <div>{subTitle}</div>
      </div>
      <CustomIcon />
      {/* <NoteAddIcon style={{ color: 'red', fontSize: '30px' }} /> */}
    </Button>
  </div>
);

SplitReport_SingleSample.propTypes = {
  onButtonClick: PropTypes.func,
  title: PropTypes.string,
  subTitle: PropTypes.string,
};
export default SplitReport_SingleSample;



// WEBPACK FOOTER //
// ./src/components/Actions/SplitReport/SplitReport_SingleSample/SplitReport_SingleSample.jsx